import { TColumn } from './column.model';
import { EDefaultColumnWidths } from './default-column-widths-enum';

const BASIC_COLUMNS_OLD = [
  'Flag',
  'Account',
  'Site',
  'Priority',
  'Status',
  'ID',
  'Title',
  'Description',
  'Created',
  'Updated',
  'Created By',
  'Assignees',
  'Tags',
];

const BASIC_COLUMNS = [
  'Flag',
  'Priority',
  'Account/Site',
  'Status',
  'ID',
  'Title',
  'Description',
  'Created',
  'Updated',
  'Created By',
  'Assignees',
  'Tags',
];

export const generateDefaultColumns = (): TColumn[] => {
  const columns = BASIC_COLUMNS_OLD;

  return columns
    .filter((_column) => _column !== 'Account' && _column !== 'Site')
    .map((_column, _index) => ({
      name: _column,
      index: _index,
      width: getDefaultWidth(_column),
    }));
};

export const generateDefaultOverviewColumns = (newFilters = false): TColumn[] => {
  const columns = newFilters ? BASIC_COLUMNS : BASIC_COLUMNS_OLD;

  return columns.map((_column, _index) => ({
    name: _column,
    index: _index,
    width: getDefaultWidth(_column),
  }));
};

export const getDefaultWidth = (_name: string): number => {
  switch (_name) {
    case 'Priority':
      return EDefaultColumnWidths.PRIORITY;
    case 'Status':
      return EDefaultColumnWidths.STATUS;
    case 'ID':
      return EDefaultColumnWidths.ID;
    case 'Flag':
      return EDefaultColumnWidths.RED_FLAG;
    case 'Title':
      return EDefaultColumnWidths.TITLE;
    case 'Description':
      return EDefaultColumnWidths.DESCRIPTION;
    case 'Created':
      return EDefaultColumnWidths.CREATED;
    case 'Updated':
      return EDefaultColumnWidths.UPDATED;
    case 'Created By':
      return EDefaultColumnWidths.CREATED_BY;
    case 'Assignees':
      return EDefaultColumnWidths.ASSIGNEES;
    case 'Tags':
      return EDefaultColumnWidths.TAGS;
    default:
      return EDefaultColumnWidths.CUSTOM_FIELD;
  }
};

export function getBasicColumns(): string[] {
  return [...BASIC_COLUMNS];
}
